import { exists } from '@/api'

export interface InterLibraryReceipt {
  receiptInfoReserve: any // 可変値のためanyとする
  receiptInfoReserveForwarding: any // 可変値のためanyとする
}

export function InterLibraryReceiptFromJSON(json: any): InterLibraryReceipt {
  return {
    receiptInfoReserve: exists(json, 'receipt_info_reserve')
      ? json.receipt_info_reserve
      : undefined,
    receiptInfoReserveForwarding: exists(
      json,
      'receipt_info_reserve_forwarding'
    )
      ? json.receipt_info_reserve_forwarding
      : undefined
  }
}
